define("shared/components/shared/appstore-links", ["exports", "@ember/component", "@ember/template-factory", "@ember/debug", "@ember/object/computed", "@ember/service", "@ember/utils", "@glimmer/component"], function (_exports, _component, _templateFactory, _debug, _computed, _service, _utils, _component2) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _class, _descriptor, _descriptor2;

  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/debug",0,"@ember/object/computed",0,"@ember/service",0,"@ember/utils",0,"@glimmer/component"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="tOB--device__downloads u--row u--row--noCollapse">
    <div class="u--col__5">
      <img class="img--appstore--qr qa--setup_qr_code" src={{this.qrCodeUrl}} />
    </div>
    <div class="u--col__7">
      <Shared::Link
        @href="http://lat.gr/latergramme-ios-store"
        @text=""
        class="img--appstore--apple"
        id="app_store"
        title={{t "account.devices.ios_icon_alt"}}
      >
        &nbsp;
      </Shared::Link>
      <Shared::Link
        @href="http://lat.gr/latergramme-android"
        @text=""
        class="img--appstore--google"
        id="app_store"
        title={{t "account.devices.android_icon_alt"}}
      >
        &nbsp;
      </Shared::Link>
    </div>
  </div>
  */
  {
    "id": "6yW9GlsR",
    "block": "[[[10,0],[14,0,\"tOB--device__downloads u--row u--row--noCollapse\"],[12],[1,\"\\n  \"],[10,0],[14,0,\"u--col__5\"],[12],[1,\"\\n    \"],[10,\"img\"],[14,0,\"img--appstore--qr qa--setup_qr_code\"],[15,\"src\",[30,0,[\"qrCodeUrl\"]]],[12],[13],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,0],[14,0,\"u--col__7\"],[12],[1,\"\\n    \"],[8,[39,0],[[24,0,\"img--appstore--apple\"],[24,1,\"app_store\"],[16,\"title\",[28,[37,1],[\"account.devices.ios_icon_alt\"],null]]],[[\"@href\",\"@text\"],[\"http://lat.gr/latergramme-ios-store\",\"\"]],[[\"default\"],[[[[1,\"\\n       \\n    \"]],[]]]]],[1,\"\\n    \"],[8,[39,0],[[24,0,\"img--appstore--google\"],[24,1,\"app_store\"],[16,\"title\",[28,[37,1],[\"account.devices.android_icon_alt\"],null]]],[[\"@href\",\"@text\"],[\"http://lat.gr/latergramme-android\",\"\"]],[[\"default\"],[[[[1,\"\\n       \\n    \"]],[]]]]],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[],false,[\"shared/link\",\"t\"]]",
    "moduleName": "shared/components/shared/appstore-links.hbs",
    "isStrictMode": false
  });

  let AppstoreLinksComponent = (_dec = (0, _computed.reads)('auth.currentUserModel.id'), (_class = class AppstoreLinksComponent extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "auth", _descriptor, this);

      _initializerDefineProperty(this, "currentUserId", _descriptor2, this);
    }

    get qrCodeUrl() {
      (false && !((0, _utils.isPresent)(this.args.origin)) && (0, _debug.assert)('The `@origin` argument is required', (0, _utils.isPresent)(this.args.origin)));
      const envOrigin = window.location.origin;
      return `${envOrigin}/devices/qr_code.png?origin=${this.args.origin}&page=later&user_id=${this.currentUserId}`;
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "currentUserId", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class));
  _exports.default = AppstoreLinksComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, AppstoreLinksComponent);
});